/**
 * Ephemeral slice that signals when GPS, compass, and prediction services
 * have finished their initial bootstrap.
 */

import { defineEphemeralSlice } from "../runtime/defineEphemeralSlice";

/**
 * State of the services bootstrap signal.
 */
export interface ServicesBootstrapState {

    /** `true` once all location/compass services have started. */
    "servicesReady": boolean;
}

/** Default state: services have not finished booting. */
export const SERVICES_BOOTSTRAP_DEFAULT: ServicesBootstrapState = { "servicesReady": false };

/**
 * Slice set by `ServicesInitializer` once the location services are started.
 * `SessionRestoreBootstrap` waits for this before unlocking the restore.
 */
export const servicesBootstrapSlice = defineEphemeralSlice<ServicesBootstrapState>( {
    "key":     "servicesBootstrap",
    "default": () => SERVICES_BOOTSTRAP_DEFAULT,
} );
